<template>
  <v-dialog v-model="plainDialogVisible" max-width="730" content-class="elevation-0">
    <v-card
      width="730"
      color="white"
      class="mb-0 pa-12 sigfloCard borderImage elevation-0"
      dark
      multi-line
      timeout="-1"
    >
      <v-row class="fill-height" align="center" justify="center">
        <v-col class="text-center">
          <div class="sigfloBodyLarge textEmphasis message pb-2">
            {{ plainDialog.messageTitle }}
          </div>
          <div class="sigfloBody400 textMuted message pb-8">
            {{ plainDialog.message }}
          </div>
          <v-btn
            v-for="button in plainDialog.buttonArray"
            :key="button.label"
            rounded
            class="mr-4 elevation-0 px-4 text-capitalize sigfloButtonSmall400"
            :color="button.color"
            @click.stop.prevent="executeCallback(button.callback)"
            ><v-icon class="mr-1">{{ button.icon }}</v-icon
            >{{ button.label }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    mounted() {},
    data() {
      return {};
    },
    methods: {
      executeCallback(callback) {
        if (callback) {
          callback();
        }
        this.hidePlainDialog();
      }
    },
    computed: {
      ...mapState('app', ['toast', 'plainDialog']),
      plainDialogVisible: {
        get() {
          return this.plainDialog.show;
        },
        set(value) {
          if (value) {
            this.$store.commit('app/showPlainDialog', true);
          } else {
            this.$store.commit('app/showPlainDialog', false);
          }
        }
      }
    }
  };
</script>

<style scoped></style>
